<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="row">
            <div class="col-12">
                <app-program-list (selectEvent)="onSelectEvent($event)"></app-program-list>
            </div>
        </div>
        <div *ngIf="!activated">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-start align-items-center">
                        <div class="mr-1"><p>Vous devez finir de compléter le questionnaire afin pouvoir consulter vos résultats</p>
                        </div>
                        <div  class="ml-auto">
                            <button class="btn btn-primary" routerLink="/questionnaire/quest">Reprendre le questionnaire</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row match-height">
            <div class="col-lg-4 col-12">
                <div class="row match-height">
                    <!-- Cyberscore -->
                    <div class="col-lg-6 col-md-3 col-6">
                        <div class="card" [ngClass]="!activated ? 'card-bg-lock-disable' : ''">
                            <div class="card-body pb-50" style="position: relative;">
                                <h6>{{'CYBERSCORE' | translate}}</h6>
                                <app-cyberscore-widget [ngClass]="!activated ? 'card-disabled-opacity' : ''"
                                                       ></app-cyberscore-widget>
                                <div class="resize-triggers">
                                    <div class="expand-trigger">
                                        <div style="width: 181px; height: 181px;"></div>
                                    </div>
                                    <div class="contract-trigger"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--/ Cyberscore -->
                    <!-- No Conformity -->
                    <div class="col-lg-6 col-md-3 col-6">
                        <div class="card card-tiny-line-stats" [ngClass]="!activated ? 'card-bg-lock-disable' : ''">
                            <div class="card-body pb-50" style="position: relative;">
                                <h6>Points d'améliorations</h6>
                                <app-improper-widget [ngClass]="!activated ? 'card-disabled-opacity' : ''"
                                                     [referencial]="referencial"></app-improper-widget>


                                <div class="resize-triggers">
                                    <div class="expand-trigger">
                                        <div style="width: 181px; height: 181px;"></div>
                                    </div>
                                    <div class="contract-trigger"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--/ No Conformity -->
                    <!-- Improve Card -->
                    <div class="col-lg-12 col-md-6 col-12">
                        <div class="card earnings-card" [ngClass]="!activated ? 'card-bg-lock-disable' : ''">
                            <div class="card-body">
                                    <h6>Type de mesures</h6>
                                    <div class="col-12" style="position: relative;">
                                        <app-amelioration-point-widget [ngClass]="!activated ? 'card-disabled-opacity' : ''"
                                                                       [referencial]="referencial"></app-amelioration-point-widget>
                                        <div class="resize-triggers">
                                            <div class="expand-trigger">
                                                <div style="width: 188px; height: 128px;"></div>
                                            </div>
                                            <div class="contract-trigger"></div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <!--/ Improve Card -->
                </div>
            </div>
            <!-- Risk analyse -->
            <div class="col-lg-8 col-12">
                <div class="card card-revenue-budget" [ngClass]="!activated ? 'card-bg-lock-disable' : ''">
                    <div class="row mx-0">
                        <div class="col-12 revenue-report-wrapper" style="position: relative;">
                            <div class="justify-content-between align-items-center">
                                <h4 class="card-title mb-50 mb-sm-0">Analyse des risques par thématique</h4>
                            </div>
                            <app-risk-analysis-widget [ngClass]="!activated ? 'card-disabled-opacity' : ''"
                                                      ></app-risk-analysis-widget>
                            <div class="resize-triggers">
                                <div class="expand-trigger">
                                    <div style="width: 536px; height: 346px;"></div>
                                </div>
                                <div class="contract-trigger"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Risk analyse Card -->
        </div>
        <div class="row match-height">
            <div class="col-12">
        <div class="card" [ngClass]="!activated ? 'card-bg-lock-disable' : ''">
            <app-recommended-actions-widget [ngClass]="!activated ? 'card-disabled-opacity' : ''"
                                            ></app-recommended-actions-widget>
        </div>
            </div>
        </div>
    </div>
</div>
